import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import {
  qAPPMain_GF_ProductsWaitingForValidation,
  QAPPMain_GF_ProductsWaitingForValidation,
} from "../../odata/appu4dm/QAppU4DM";
import { odataFetch } from "../../lib/odata-fetch";
import { APPMain_GF_ProductsWaitingForValidation } from "../../odata/appu4dm/AppU4DMModel";
import { useQuery } from "@tanstack/react-query";
import { useMachine } from "../machine/use-machine";
import { useMTUs } from "../mtu/use-mtus";
import { taskKeys } from "./task-keys";

export function useProductsWaitingForValidation() {
  const { machine } = useMachine();
  const { selected } = useMTUs();
  const { data, ...query } = useQuery({
    queryKey: taskKeys.getProductsWaitingForValidation(
      machine?.EquipmentNId,
      selected?.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code
    ),
    queryFn: ({ meta }) =>
      fetchProductsWaitingForValidation(
        {
          machineId: machine!.EquipmentNId!,
          mtu: selected!.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code!,
        },
        meta!.token!
      ),
    enabled: ({ meta }) =>
      !!meta?.token &&
      !!machine?.EquipmentNId &&
      !!selected?.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code,
  });

  return {
    productsWaitingForValidation: data?.value,
    ...query,
  };
}

async function fetchProductsWaitingForValidation(
  payload: {
    machineId: string;
    mtu: string;
  },
  token: string
) {
  const builder = createQueryBuilderV4(
    "APPMain_GF_ProductsWaitingForValidation",
    new QAPPMain_GF_ProductsWaitingForValidation()
  ).filter(
    qAPPMain_GF_ProductsWaitingForValidation.WorkcenterNId.eq(
      payload.machineId
    ).and(qAPPMain_GF_ProductsWaitingForValidation.ProductId.eq(payload.mtu))
  );

  return odataFetch<APPMain_GF_ProductsWaitingForValidation>({
    builder,
    token,
  });
}
